/* eslint-disable max-len */
import ROUTES from 'config/routes';

export const SOLUTIONS_ITEMS = [
  {
    id: 1,
    name: 'solutions.collectReviews.name',
    link: ROUTES.COLLECTING_REVIEWS,
    description: 'solutions.collectReviews.description',
    icon: 'collecting-reviews',
    aTag: false,
  },
  {
    id: 2,
    name: 'solutions.increaseSale.name',
    link: ROUTES.INCREASE_SALES,
    description: 'solutions.increaseSale.description',
    icon: 'increase-sales',
    aTag: false,
  },
  {
    id: 3,
    name: 'solutions.traffic.name',
    link: ROUTES.TRAFFIC,
    description: 'solutions.traffic.description',
    icon: 'traffic',
    aTag: false,
  },
  {
    id: 4,
    name: 'solutions.effigy.name',
    link: ROUTES.CLIENT_CONTACT,
    description: 'solutions.effigy.description',
    icon: 'effigy',
    aTag: false,
  },
  {
    id: 5,
    name: 'solutions.google.name',
    link: ROUTES.GOOGLE,
    description: 'solutions.google.description',
    icon: 'google',
    aTag: false,
  },
  {
    id: 6,
    name: 'whyUs.reviewTranslate.name',
    link: ROUTES.REVIEW_TRANSLATE,
    description: 'whyUs.reviewTranslate.description',
    icon: 'translate',
    aTag: false,
  },
  {
    id: 7,
    name: 'solutions.crossborderSales.name',
    link: ROUTES.CROSSBORDER_SALES,
    description: 'solutions.crossborderSales.description',
    icon: 'globe',
    aTag: false,
  },
  {
    id: 8,
    name: 'solutions.surveysPolls.name',
    link: ROUTES.SURVEYS_AND_POLLS,
    description: 'solutions.surveysPolls.description',
    icon: 'surveys',
    aTag: false,
  },
  {
    id: 9,
    name: 'solutions.productPolls.name',
    link: ROUTES.PRODUCT_POLLS,
    description: 'solutions.productPolls.description',
    icon: 'product-polls',
    aTag: false,
  },
  {
    id: 10,
    name: 'solutions.badges.name',
    link: ROUTES.BADGES,
    description: 'solutions.badges.description',
    icon: 'badges',
    aTag: false,
  },
  {
    id: 11,
    name: 'solutions.moreSales.name',
    link: ROUTES.MORE_SALES,
    description: 'solutions.moreSales.description',
    icon: 'more-sales',
    aTag: false,
  },
  {
    id: 12,
    name: 'solutions.integrations.name',
    link: ROUTES.INTEGRATIONS,
    description: 'solutions.integrations.description',
    icon: 'integrations',
    aTag: false,
  },
  {
    id: 13,
    name: 'GMB Masters',
    link: ROUTES.GMB_MASTERS,
    description: 'solutions.gmbMasters.description',
    icon: 'gmb-masters',
    aTag: true,
  },
];

export const WHY_US_ITEMS = [
  {
    id: 1,
    name: 'whyUs.whyUs.name',
    link: ROUTES.WHY_US,
    description: 'whyUs.whyUs.description',
    icon: 'why-us',
    aTag: true,
  },
  {
    id: 2,
    name: 'whyUs.references.name',
    link: ROUTES.USE_CASE,
    description: 'whyUs.references.description',
    icon: 'references',
    aTag: true,
  },
  {
    id: 3,
    name: 'whyUs.reviews.name',
    link: ROUTES.REVIEW_COLLECTION,
    description: 'whyUs.reviews.description',
    icon: 'review-collection',
    aTag: false,
  },
];
